import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-0 border-b border-border">
        <div className="md:col-span-6 p-10 md:p-16 border-r border-border">
          <div className="overline text-muted-foreground mb-4">Vol. 01 — Editorial content, on autopilot</div>
          <h3 className="font-serif-display text-4xl md:text-5xl leading-none tracking-tight">
            Publish like a newsroom.
            <br />
            Bill like a SaaS.
          </h3>
          <p className="mt-6 max-w-lg text-muted-foreground text-base md:text-lg leading-relaxed">
            Draftwave is a content studio + subscription business in one box. Sign up, ship a
            week of content before lunch, and let recurring revenue compound in the background.
          </p>
          <div className="mt-8 text-sm text-muted-foreground space-y-1">
            <div className="overline text-[10px]">Draftwave Editorial Co.</div>
            <div className="font-mono not-italic text-xs">
              11642 Victory Blvd, Unit 2032
              <br />
              North Hollywood, CA 91606
            </div>
            <div className="font-mono text-xs">
              <a href="mailto:info@draftwave.online" className="hover:text-primary" data-testid="footer-email">
                info@draftwave.online
              </a>
            </div>
          </div>
        </div>
        <div className="md:col-span-2 p-8 border-r border-border">
          <div className="overline text-muted-foreground mb-3">Personal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/login" className="hover:text-primary" data-testid="footer-signin">Sign in</Link></li>
            <li><Link to="/login" className="hover:text-primary" data-testid="footer-signup">Create account</Link></li>
            <li><Link to="/dashboard" className="hover:text-primary" data-testid="footer-dashboard">Dashboard</Link></li>
            <li><Link to="/billing" className="hover:text-primary" data-testid="footer-billing">Billing</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2 p-8 border-r border-border">
          <div className="overline text-muted-foreground mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-primary" data-testid="footer-about">About</Link></li>
            <li><Link to="/contact" className="hover:text-primary" data-testid="footer-contact">Contact</Link></li>
            <li><Link to="/pricing" className="hover:text-primary" data-testid="footer-pricing">Pricing</Link></li>
            <li><Link to="/tools" className="hover:text-primary" data-testid="footer-tools">Free tools</Link></li>
            <li><Link to="/how-to-draft" className="hover:text-primary" data-testid="footer-how-to-draft">How To Draft</Link></li>
            <li><Link to="/blog" className="hover:text-primary" data-testid="footer-journal">The Lab</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2 p-8">
          <div className="overline text-muted-foreground mb-3">Legal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:text-primary" data-testid="footer-terms">Terms</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-primary" data-testid="footer-privacy">Privacy</Link></li>
            <li><Link to="/legal/refund" className="hover:text-primary" data-testid="footer-refund">Refund policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-wrap items-center gap-6 text-xs text-muted-foreground font-mono">
        <span>© {new Date().getFullYear()} Draftwave Editorial Co.</span>
        <span className="uppercase tracking-widest">Made in Los Angeles</span>
        <span className="ml-auto">v1.0</span>
      </div>
    </footer>
  );
}
